// extracted by mini-css-extract-plugin
module.exports = {"recordLabelCustomStyle":"ExlyTableStyles_recordLabelCustomStyle__30gU6","showTableActionComponentWrapper":"ExlyTableStyles_showTableActionComponentWrapper__2MECY"};